import { PssInventoryItem, PssItemDesign, PssCrewMember } from '../../../services/pss-auth.service';

export function parseItemBonusValue(raw?: string): number {
  if (!raw) return 0;
  const match = raw.trim().match(/[-+]?[0-9]*\.?[0-9]+/);
  if (!match) return 0;
  const n = Number(match[0]);
  return Number.isFinite(n) ? n : 0;
}

export function collectItemStatEntry(entries: Array<{stat: string; value: number}>, type: string | undefined, rawValue: string | undefined): void {
  if (!type || type.trim().toLowerCase() === 'none') return;
  const value = parseItemBonusValue(rawValue);
  if (value === 0) return;
  entries.push({ stat: type.trim(), value });
}

export function itemDesignStatEntries(design: PssItemDesign): Array<{stat: string; value: number}> {
  const entries: Array<{stat: string; value: number}> = [];
  collectItemStatEntry(entries, design.enhancementType, design.enhancementValue || design.modifier);
  collectItemStatEntry(entries, design.enhancementType2, design.enhancementValue2 || design.modifier2);
  collectItemStatEntry(entries, design.bonusEnhancementType, design.bonusEnhancementValue);
  collectItemStatEntry(entries, design.bonusEnhancementType2, design.bonusEnhancementValue2);
  return entries;
}

export function itemInstanceBonusEntries(item: PssInventoryItem, instanceId: string): Array<{stat: string; value: number}> {
  const entries: Array<{stat: string; value: number}> = [];
  if (!item.instanceBonuses) return entries;
  for (const inst of item.instanceBonuses.filter(b => b.itemId === instanceId)) {
    collectItemStatEntry(entries, inst.enhancementType, inst.enhancementValue);
    collectItemStatEntry(entries, inst.enhancementType2, inst.enhancementValue2);
  }
  return entries;
}

export function itemStatEntries(item: PssInventoryItem, designs: Map<string, PssItemDesign>, crew?: PssCrewMember): Array<{stat: string; value: number}> {
  const design = designs.get(item.designId);
  if (!design) return [];

  const entries = itemDesignStatEntries(design);

  let instanceId: string | undefined;
  if (crew && item.equippedItemIds?.length && item.equippedBy.length) {
    const idx = item.equippedBy.findIndex(c => c.characterId === crew.characterId);
    if (idx >= 0 && idx < item.equippedItemIds.length) {
      instanceId = item.equippedItemIds[idx];
    }
  }

  if (instanceId) {
    entries.push(...itemInstanceBonusEntries(item, instanceId));
  }

  return entries;
}

export function itemCrewStat(item: PssInventoryItem, designs: Map<string, PssItemDesign>, crew: PssCrewMember): string {
  const info = itemCrewStatInfo(item, designs, crew);
  return info.text;
}

export function itemCrewStatInfo(item: PssInventoryItem, designs: Map<string, PssItemDesign>, crew: PssCrewMember): { text: string; matchMain: boolean } {
  const entries = itemStatEntries(item, designs, crew);
  if (!entries.length) return { text: '', matchMain: false };
  const main = entries[0];
  const secondary = entries.length > 1 ? entries[1] : entries[0];
  const text = `${secondary.stat} ${secondary.value >= 0 ? '+' : ''}${secondary.value}`;
  const matchMain = secondary.stat.toLowerCase() === main.stat.toLowerCase();
  return { text, matchMain };
}

export function itemAssignedStat(item: PssInventoryItem, designs: Map<string, PssItemDesign>): string {
  const entries = itemStatEntries(item, designs);
  if (!entries.length) return '';
  const stat = entries.length > 1 ? entries[1] : entries[0];
  return `${stat.stat} ${stat.value >= 0 ? '+' : ''}${stat.value}`;
}
